export type ThemePreference = 'light' | 'dark' | 'system';
export const isThemePreference = (value: unknown): value is ThemePreference => value === 'light' || value === 'dark' || value === 'system';
export function readThemePreference(): ThemePreference {
  try { const value = localStorage.getItem('legea-theme'); return isThemePreference(value) ? value : 'system'; } catch { return 'system'; }
}
export function applyThemePreference(theme: ThemePreference) {
  const resolved = theme === 'system' ? (matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light') : theme;
  document.documentElement.classList.toggle('dark', resolved === 'dark');
  document.documentElement.dataset.themePreference = theme;
  document.documentElement.style.colorScheme = resolved;
  return resolved;
}
export function persistThemePreference(theme: ThemePreference) {
  try { localStorage.setItem('legea-theme', theme); } catch { /* The current session remains usable when storage is unavailable. */ }
}
export function setupStaticThemeControls() {
  const control = document.getElementById('home-theme-control');
  if (!control) return () => {};
  let preference = readThemePreference();
  const toggleBtn = control.querySelector<HTMLButtonElement>('button[data-theme-toggle]') || control.querySelector<HTMLButtonElement>('button');
  const render = () => {
    const resolved = applyThemePreference(preference);
    if (toggleBtn) {
      const isDark = resolved === 'dark';
      if (!toggleBtn.querySelector('.theme-toggle-sun')) {
        toggleBtn.textContent = isDark ? '☀' : '☾';
      }
      const label = isDark ? 'Activează tema luminoasă' : 'Activează tema întunecată';
      toggleBtn.setAttribute('aria-label', label);
      toggleBtn.setAttribute('title', label);
      toggleBtn.dataset.themeCurrent = resolved;
    }
    control.querySelectorAll<HTMLButtonElement>('button[data-theme-choice]').forEach(button => button.setAttribute('aria-pressed', String(button.dataset.themeChoice === preference)));
  };
  const click = (event: Event) => {
    const choice = (event.target as Element).closest<HTMLButtonElement>('button[data-theme-choice]')?.dataset.themeChoice;
    if (isThemePreference(choice)) {
      preference = choice;
      persistThemePreference(choice);
      render();
      return;
    }
    const isToggle = (event.target as Element).closest<HTMLButtonElement>('button[data-theme-toggle]') || (event.target as Element).closest<HTMLButtonElement>('button');
    if (isToggle) {
      const currentResolved = document.documentElement.classList.contains('dark') ? 'dark' : 'light';
      const next: ThemePreference = currentResolved === 'dark' ? 'light' : 'dark';
      preference = next;
      persistThemePreference(next);
      render();
    }
  };
  const storage = (event: StorageEvent) => { if (event.key === 'legea-theme' || event.key === null) { preference = readThemePreference(); render(); } };
  const media = matchMedia('(prefers-color-scheme: dark)');
  control.hidden = false; render(); control.addEventListener('click', click); media.addEventListener('change', render); window.addEventListener('storage', storage);
  return () => { control.removeEventListener('click', click); media.removeEventListener('change', render); window.removeEventListener('storage', storage); };
}

